import React from 'react';

import { SeekTable } from 'components/seekTable/seekTable';
import { Button } from 'components/button/button';

export function DeviceIdentityMapping(props) {
  return (
    <React.Fragment>
      <SeekTable
        location={props.location}
        path={props.path}
        name="Device Identity Mapping"
        reportId="45d77f9968064b2db7b909705d19b6d1"
        bottomOffset={50}
      />
      <div style={{ position: 'absolute', bottom: 15 }}>
        <Button
          text="Edit Device Identity Mapping"
          url="/edit-device-identity-mapping"
        />
      </div>{' '}
    </React.Fragment>
  );
}
